import AppLanguagePicker from '@map/components/AppLanguagePicker';
import GuestAreaAppBar from '@map/components/GuestArea/GuestAreaAppBar';
import useViewportMatch from '@shared/hooks/useViewportMatch';
import { Route } from 'react-router-dom';
import { guestLinks } from './links';

const Navigation = () => {
  const isMobile = useViewportMatch('md', 'down');

  return (
    <GuestAreaAppBar backLink={true} inverse={isMobile}>
      <Route exact path={[guestLinks.authentication(), guestLinks.register()]}>
        <AppLanguagePicker variant="short" />
      </Route>
    </GuestAreaAppBar>
  );
};

export default Navigation;
